import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWhitesourceComponent } from './simple-icons-whitesource.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWhitesourceComponent ],
    exports:      [ SimpleIconsWhitesourceComponent ],
    bootstrap:    []
})
export class SimpleIconsWhitesourceModule {}
